export const FORM_DATA_HEADERS = {
  'Content-Type': 'multipart/form-data'
}
